import { RouteProviderService } from '@web/common';
import { TableItemActionBuilder } from '../builders/table-item-action.builder';
import { inject, Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class TableItemActionBuilderFactory {
  private readonly provider = inject(RouteProviderService);

  public create<Item, Action>(): TableItemActionBuilder<Item, Action> {
    return new TableItemActionBuilder<Item, Action>(this.provider);
  }
}
